module.exports = __webpack_public_path__ + "assets/img/55d5-kw.svg";